module.exports = __webpack_public_path__ + "img/nachhilfe-lg.4d4b76ac.webp";